import NewBookingTravelClassInterface from '../interfaces/client/NewBookingTravelClass'

export const recursivelyCreateNewBookingTravelClassRow = (
  rowId: number,
  travelClassType: string,
  RowTravelClass: NewBookingTravelClassInterface[]
): NewBookingTravelClassInterface[] => {
  if (!rowId) return RowTravelClass

  const newRowId = rowId - 1
  const newRowTravelClassType = [...RowTravelClass, { travelClassType }]

  return recursivelyCreateNewBookingTravelClassRow(
    newRowId,
    travelClassType,
    newRowTravelClassType
  )
}

export default recursivelyCreateNewBookingTravelClassRow
